"use client"

import clsx from "clsx"
import { motion } from "framer-motion"
import type { Variants } from "framer-motion"
import type { Ref } from "react"
import React, { useContext } from "react"

import PageThemeContext from "../../page-theme/PageThemeContext"
import type { TSubMenu } from "../types/navigation"

import SubmenuLink from "./SubmenuLink"

const SubmenuMobile: React.FC<TSubMenu> = React.forwardRef(
  ({ heading, links }, ref: Ref<HTMLDivElement>) => {
    const submenuItemVariants: Variants = {
      open: {
        opacity: 1,
      },
      closed: {
        opacity: 0,
      },
    }
    const pageThemeContext = useContext(PageThemeContext)
    const headingTextColorClass = pageThemeContext.pageTheme.dark
      ? "text-gray-40"
      : "text-gray-60"
    return (
      <div
        ref={ref}
        className="pl-8 mb-12 col-span-full md:mb-0 md:col-span-2 lg:col-span-4 md:p-4"
      >
        {heading ? (
          <motion.h2
            variants={submenuItemVariants}
            className={clsx(
              "mb-6 text-sm all-caps-small md:mb-8 lg:mb-10",
              headingTextColorClass,
            )}
          >
            {heading}
          </motion.h2>
        ) : (
          <div className="md:mb-0 md:mt-13" />
        )}
        {links.map(({ linkTo, heading: linkHeading, subheading, outbound }) => (
          <motion.div key={linkTo} variants={submenuItemVariants}>
            <SubmenuLink
              linkTo={linkTo}
              heading={linkHeading}
              subheading={subheading}
              outbound={outbound}
            />
          </motion.div>
        ))}
      </div>
    )
  },
)
export default motion(SubmenuMobile, { forwardMotionProps: true })
